import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { LicitacaoAudesp } from 'eddydata-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LicitacaoAudespService } from '../../service/licitacao-audesp.service';

@Component({
  selector: 'lib-licitacao-audesp-documento-fiscal-list',
  templateUrl: './licitacao-audesp-documento-fiscal-list.component.html'
})
export class LicitacaoAudespDocumentoFiscalListComponent implements OnChanges, OnDestroy {

  @Input() public licitacao: number;
  @Input() public registroPreco: number;
  @Input() public ajuste: number;
  public listaDocumentoFiscal: LicitacaoAudesp[];

  protected unsubscribe: Subject<void> = new Subject();

  constructor(private audespService: LicitacaoAudespService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.ajuste) {
      this.audespService.filtrar(0, 0, { parente_id: this.ajuste, tipo: 'DOC_FISCAL' }).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          this.listaDocumentoFiscal = res?.content ? res.content : [];
          this.listaDocumentoFiscal.forEach(item => item.identificacao = item.identificacao.replace(', ', '<br>'))
        })
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
